declare global {
  interface Window {
    dataLayer: any;
  }
}

const trackProductProtectionWhatIsCoveredMoreDetialsLink = (data, pageType) => {
  const event = 'product_protection_whats_covered_drawer_more_details_link'

  const logData = {
    event,
    page: pageType,
    ...data,
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(logData)
}

export default trackProductProtectionWhatIsCoveredMoreDetialsLink
